import { Injectable, inject } from '@angular/core';
import { API_GATEWAY_CONFIG, ApiGatewayConfig, ApiGatewayService } from '@drc-eca/eca-components-lib';

@Injectable({
  providedIn: 'root'
})
export class LocalSecurityService {
  config = inject<ApiGatewayConfig>(API_GATEWAY_CONFIG, { optional: true })!;
  private apiGatewaySvc = inject(ApiGatewayService);

  constructor() {}

  getServiceName () {
    return `${this.config['securityServiceUrl']}`;
  }

  authenticate = (username: string, password: string)=>{
    const data: any = {
      username: username,
      password: password
    };
    return this.apiGatewaySvc.post(`${this.getServiceName()}/admin/user`, data, this.getOptions());
  }

  register = (data: any)=>{
    return this.apiGatewaySvc.put(`${this.getServiceName()}/admin/user`, data, this.getOptions());
  }

  authenticateToken = (token: string)=>{
    return this.apiGatewaySvc.get(`${this.getServiceName()}/admin/user?token=${token}`, this.getOptions());
  }

  refreshToken = (token: string)=>{
    return this.apiGatewaySvc.get(`${this.getServiceName()}/admin/user?token=${token}`, this.getOptions());
  }

  private getOptions(){     
    const options: any = {
      httpOptions : {
        headers : {'authsource': sessionStorage.getItem('localSecurityOn') === 'true' ? 'local' : 'eca-security-service'}
      },
      includeToken: true,
      withCredentials: false
    };

    return options;
  }

}
